import { useHomeBanner } from "../../Pregrine/HomeBanner/useHomeBanner";
import Slider from "react-slick";
import classes from "./HomeBanner.module.css";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import StaticBannerMobile from "../../assets/images/static_banner_mobile.png";
import StaticBannerDesktop from "../../assets/images/static_banner_desktop.png";
import classNames from "classnames";

const HomeBanner = () => {
  const talonProps = useHomeBanner();
  const { HomeBannersData } = talonProps;

  const settings = useMemo(
    () => ({
      dots: true,
      arrows: false,
      autoplay: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      appendDots: (dots) => (
        <div className={classes.sliderDots}>
          <ul>{dots}</ul>
        </div>
      ),
      customPaging: (i) => (
        <div className={classes.bannerFooterItem}>
          <h5>{HomeBannersData.sliderdata[i].banner_title}</h5>
          <p>
            <small>{HomeBannersData.sliderdata[i].label_button_text}</small>
          </p>
        </div>
      ),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            appendDots: (dots) => (
              <div>
                <ul>{dots}</ul>
              </div>
            ),
            customPaging: (i) => (
              <div>
                <p
                  style={{
                    opacity: "0",
                    marginTop: "-10px",
                    marginLeft: "-6px",
                  }}
                >
                  {i}
                </p>
              </div>
            ),
          },
        },
      ],
    }),
    [HomeBannersData]
  );

  return (
    <div className={`${classes.rootBanner} homeBanner`}>
      <div className={classes.homepageBanner}>
        <Slider {...settings}>
          {HomeBannersData &&
          HomeBannersData.sliderdata &&
          HomeBannersData.sliderdata.length ? (
            HomeBannersData.sliderdata.map((banner, index) => (
              <div className={classes.bannerItem} key={index}>
                {banner.banner_type === "Image" ? (
                  <Link to={banner.call_to_action}>
                    <div className={classes.pictureWrapper}>
                      <picture>
                        <source
                          media="(min-width:650px)"
                          srcSet={banner.banner_image}
                          width={1920}
                          height={600}
                        />
                        <source
                          media="(min-width:465px)"
                          srcSet={banner.banner_image_mobile}
                          width={450}
                          height={450}
                        />
                        <img
                          src={banner.banner_image_mobile}
                          alt={banner.banner_title}
                          width={450}
                          height={450}
                          fetchPriority={index === 0 ? "high" : "auto"}
                          loading={index === 0 ? "eager" : "lazy"}
                        />
                      </picture>
                    </div>
                  </Link>
                ) : null}

                {banner.banner_type === "Video" ? (
                  <video
                    autoPlay
                    muted
                    loop
                    width={1920}
                    height={600}
                    fetchpriority={index === 0 ? "high" : "low"}
                  >
                    <source src={banner.banner_video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : null}
              </div>
            ))
          ) : (
            <div className={classNames(classes.bannerItem, "placeholder-glow")}>
              <picture>
                <source
                  media="(min-width:650px)"
                  srcSet={StaticBannerDesktop}
                  width={1920}
                  height={600}
                />
                <source
                  media="(min-width:465px)"
                  srcSet={StaticBannerMobile}
                  width={1920}
                  height={600}
                />
                <img
                  src={StaticBannerMobile}
                  alt={""}
                  width={1920}
                  height={600}
                  fetchPriority="high"
                />
              </picture>
              <div className={classes.fakeDots}></div>
            </div>
          )}
        </Slider>
      </div>
    </div>
  );
};

export default HomeBanner;
